export default __webpack_public_path__ + "static/media/icon-volume.04cf4ede.svg";